import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13cb5cb2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb5cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/weikang/weikang-lc-mer-mer-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cb5cb2')) {
      api.createRecord('13cb5cb2', component.options)
    } else {
      api.reload('13cb5cb2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13cb5cb2&scoped=true", function () {
      api.rerender('13cb5cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/activityProduct/goodListFrom/index.vue"
export default component.exports